import { Action } from '@ngrx/store';
import { WindowConfig } from './window-config';
import { v1 as uuid } from 'uuid';

export enum WindowActionTypes {
  OpenWindow       = '@digitaix/core/window/OPEN_WINDOW',
  MinimizeWindow   = '@digitaix/core/window/MINIMIZE_WINDOW',
  CloseWindow      = '@digitaix/core/window/CLOSE_WINDOW',
  ReopenWindow     = '@digitaix/core/window/REOPEN_WINDOW',
  FullScreenWindow = '@digitaix/core/window/FULL_SCREEN_WINDOW',
  SetWindowTitle   = '@digitaix/core/window/SET_WINDOW_TITLE',
  SetWindowIcon    = '@digitaix/core/window/SET_WINDOW_ICON',
  SetWindowWidth   = '@digitaix/core/window/SET_WINDOW_WIDTH',
  SetWindowHeight  = '@digitaix/core/window/SET_WINDOW_HEIGHT',
  SetWindowPositiion = '@digitaix/core/window/SET_WINDOW_POSITION',
  WindowOpend = '@digitaix/core/window/WINDOW_OPENED',
}

export class WindowOpend<D, T> implements Action {
  public readonly type = WindowActionTypes.WindowOpend;

  constructor(public config: WindowConfig<D, T>, public windowId: string = config.id || uuid(), public tracer?: string) {}
}

export class SetWindowPositiion implements Action {
  public readonly type = WindowActionTypes.SetWindowPositiion;

  constructor(public windowId: string, public x: string, public y: string, public tracer?: string) {}
}

export class OpenWindow<D, T> implements Action {
  public static TYPE = '@digitaix/core/window/OPEN_WINDOW';
  public readonly type = OpenWindow.TYPE;

  constructor(public config: WindowConfig<D, T>, public tracer?: string) {}
}

export class SetWindowWidth implements Action {
  public readonly type = WindowActionTypes.SetWindowWidth;

  constructor(public windowId: string, public width: string, public tracer?: string) {}

}

export class SetWindowHeight implements Action {
  public readonly type = WindowActionTypes.SetWindowHeight;

  constructor(public windowId: string, public height: string, public tracer?: string) {}

}

export class MinimizeWindow implements Action {
  public readonly type = WindowActionTypes.MinimizeWindow;

  constructor(public windowId: string, public tracer?: string) {}

}

export class CloseWindow implements Action {
  public readonly type = WindowActionTypes.CloseWindow;

  constructor(public windowId: string, public tracer?: string) {}

}

export class ReopenWindow implements Action {
  public readonly type = WindowActionTypes.ReopenWindow;

  constructor(public windowId: string, public tracer?: string) {}

}

export class FullScreenWindow implements Action {
  public readonly type = WindowActionTypes.FullScreenWindow;

  constructor(public windowId: string, public tracer?: string) {}

}

export class SetWindowTitle implements Action {
  public readonly type = WindowActionTypes.SetWindowTitle;

  constructor(public windowId: string, public title: string, public tracer?: string) {}

}

export class SetWindowIcon implements Action {
  public readonly type = WindowActionTypes.SetWindowIcon;

  constructor(public windowId: string, public icon: string, public tracer?: string) {}

}


export type WindowActions =
  WindowOpend<any, any>
  | CloseWindow
  | MinimizeWindow
  | ReopenWindow
  | FullScreenWindow
  | SetWindowTitle
  | SetWindowIcon
  | SetWindowHeight
  | SetWindowPositiion
  | SetWindowWidth;
